import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { FullPageLoadingSpinner } from 'shared/components/FullPageLoadingSpinner.tsx';

export const DefaultLayout = () => {
  return (
    <main className="mx-auto flex min-h-full-device items-center justify-center sm:max-w-container">
      <Suspense fallback={<FullPageLoadingSpinner size={48} />}>
        <Outlet />
      </Suspense>
    </main>
  );
};
